import Vue from 'vue'
import Router from 'vue-router'
/** 登录页 */
import LoginPage from '@/components/Login'
/** 注册页 */
import RegisterPage from '@/components/Register'
/** 前台 */
import FrontPage from '@/components/common/Front.vue'
/** 前台-首页 */
import FrontHomePageIndex from '@/components/front/home'
/** 前台-电子书二级 */
import DzsListPageIndex from '@/components/front/dzslist'
/** 前台-电子书详情 */
import DzsDetailPageIndex from '@/components/front/dzsdetail'
/** 前台-视频二级 */
import SpListPageIndex from '@/components/front/splist'
/** 前台-视频二级更多 */
import SpListMorePageIndex from '@/components/front/splistmore'
/** 前台-视频详情 */
import SpDetailPageIndex from '@/components/front/spdetail'
/** 前台-论文二级 */
import LwListPageIndex from '@/components/front/lwlist'
/** 前台-论文详情 */
import LwDetailPageIndex from '@/components/front/lwdetail'
/** 前台-视频二级更多 */
import LwListMorePageIndex from '@/components/front/lwlistmore'


/** 后台 */
import AdminPage from '@/components/common/Admin'
/** 后台-首页 */
import SyPageIndex from '@/components/sy/index'
/** 后台-首页资源 */
import SyzyPageIndex from '@/components/syzy/index'
/** 后台-电子书 */
import DzsPageIndex from '@/components/dzs/index'
/** 后台-视频 */
import SpPageIndex from '@/components/sp/index'
/** 后台-论文 */
import LwPageIndex from '@/components/lw/index'
import LwPageIndex03 from '@/components/lw/index03'

import LwflglPageIndex from '@/components/lw/lwflgl'

import TestTab from '@/components/TestTab'
import FlexTest from '@/components/FlexTest'
import PosiTest from '@/components/PosiTest'
import Transfer from '@/components/transfer'
/** 后台-视频 */
import JcPageIndex from '@/components/jc/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/register',
      name: 'RegisterPage',
      component: RegisterPage
    },
    {
      path: '/onlyLw',
      name: 'LwPageIndex',
      component: LwPageIndex
    },
    {
      path: '/onlyLw03',
      name: 'LwPageIndex03',
      component: LwPageIndex03
    },

    {
      path: '/admin',
      name: 'AdminPage',
      component: AdminPage,
      children: [
        {
          path: 'syzy',
          name: 'SyzyPageIndex',
          component: SyzyPageIndex
        },
        {
          path: 'sy',
          name: 'SyPageIndex',
          component: SyPageIndex
        },
        {
          path: 'dzs',
          name: 'DzsPageIndex',
          component: DzsPageIndex
        },
        {
          path: 'sp',
          name: 'SpPageIndex',
          component: SpPageIndex
        },
        {
          path: 'jc',
          name: 'JcPageIndex',
          component: JcPageIndex
        },
        {
          path: 'lwflgl',
          name: 'LwflglPageIndex',
          component: LwflglPageIndex
        }
      ]
    },
    {
      path: '/front',
      name: 'FrontPage',
      component: FrontPage,
      redirect: '/front/home',
      children: [
        {
          path: 'home',
          name: 'FrontHomePageIndex',
          component: FrontHomePageIndex
        },{
          path: 'dzslist',
          name: 'DzsListPageIndex',
          component: DzsListPageIndex
        }, {
          path: 'dzsdetail',
          name: 'DzsDetailPageIndex',
          component: DzsDetailPageIndex
        }, {
          path: 'splist',
          name: 'SpListPageIndex',
          component: SpListPageIndex
        },{
          path: 'spdetail',
          name: 'SpDetailPageIndex',
          component: SpDetailPageIndex
        }, {
          path: 'splistmore',
          name: 'SpListMorePageIndex',
          component: SpListMorePageIndex
        },
        {
          path: 'lwlist',
          name: 'LwListPageIndex',
          component: LwListPageIndex
        }, {
          path: 'lwdetail',
          name: 'LwDetailPageIndex',
          component: LwDetailPageIndex
        },
        {
          path: 'lwlistmore',
          name: 'LwListMorePageIndex',
          component: LwListMorePageIndex
        }
      ]
    },
    {
      path: '/testTab',
      name: 'TestTab',
      component: TestTab
    },
    {
      path: '/flexTest',
      name: 'FlexTest',
      component: FlexTest
    },
    {
      path: '/posiTest',
      name: 'PosiTest',
      component: PosiTest
    },
    {
      path: '/transfer',
      name: 'Transfer',
      component: Transfer
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js